import { useNavigate } from "react-router-dom";
import { Avatar, Box, IconButton, Link, Typography } from "@mui/material";

import { Review } from "../../../../../types/types";
import { formatLocalizedTimeAgo } from "../../../../../utils/formatDate";
import { testimonialStyles } from "../styles";

import { useUserDataFormatter } from "../../../../User/hooks/useUserDataFormatter";
import { OptionIcon } from "../../../assets/icons/player-icons";

const TestimonialCardHeader = ({ review }: { review: Review }) => {
  const navigate = useNavigate();
  const { reviewer } = review;

  const { fullName, firstTwoChr, media, role, profileLink } = useUserDataFormatter(reviewer);
  const timeAgo = formatLocalizedTimeAgo(new Date(review.reviewInfo.createdAt).toISOString());

  return (
    <Box sx={testimonialStyles.card.header.container}>
      <Box sx={testimonialStyles.card.header.avatarContainer}>
        <Avatar src={media} sx={{ width: 40, height: 40 }}>
          {firstTwoChr}
        </Avatar>
        <Box sx={testimonialStyles.card.header.userInfo}>
          <Link sx={testimonialStyles.card.header.userName} onClick={() => navigate(profileLink)}>
            {fullName}
          </Link>
          <Typography sx={testimonialStyles.card.header.userMeta}>
            {role}
            {role && " • "}
            {timeAgo}
          </Typography>
        </Box>
      </Box>

      <IconButton>
        <OptionIcon />
      </IconButton>
    </Box>
  );
};

export default TestimonialCardHeader;
